import axios from 'axios';
import authConfig from '../auth_config.json';

class PlaygroundService {
    domain = authConfig.domain;

    getFormActivity(playgroundId) {

        return new Promise((resolve, reject) => {
            axios({url: this.domain+'activity-booking/form-activity-slot/'+playgroundId, method: 'GET' })
                .then(resp => {
                    return resolve(resp.data)
                })
                .catch(err => {
                    return reject(err)
                })
        })
    }

    addActivity(activitySlot, nbPlayer, duration, data) {

        return new Promise((resolve, reject) => {
            axios({url: this.domain+'activity-booking/form-activity-slot/'+playgroundId, method: 'GET' })
                .then(resp => {
                    return resolve(resp.data)
                })
                .catch(err => {
                    return reject(err)
                })
        })

    }

    cancelActivity(activityId) {

        return new Promise((resolve, reject) => {
            axios({url: this.domain+'activity-booking/form-activity-slot/'+playgroundId, method: 'GET' })
                .then(resp => {
                    return resolve(resp.data)
                })
                .catch(err => {
                    return reject(err)
                })
        })
    }

}

const playgroundService = new PlaygroundService();

export default playgroundService;
